import { UserState } from './../../redux/user/userSlice';
import { random } from '../random';
import { theme } from '../../styles/themeStyles';
export const firstLetter = (text: string) => text?.split('')[0] || '';
export const colorRandom = theme.color.users[random(0, theme.color.users.length)];
export const completeUserData = (user: UserState, token: string) => {
    const name = user?.name || user?.first_name || '';
    return {
        id: user?.id,
        first_name: name?.split(' ')[0],
        letters: user?.letters || firstLetter(name),
        color: user?.color || colorRandom,
        name: user?.name,
        email: user?.email || '',
        phone: user?.phone || '',
        telefono_cel: user?.phone || '',
        image: user?.image || '',
        token: token,
        is_admin: user.is_admin,
        role_id: parseInt(user?.role_id?.toString()) || 1,
    };
};


export const sortByKey = (arr, key) => {
    return arr.sort((a, b) => {
      if (a[key].toLowerCase() < b[key].toLowerCase()) {
        return -1;
      }
      if (a[key].toLowerCase() > b[key].toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }